import { getDashboardFlags } from '@applications/channel-care';

export default class Routes {
    public static get ChannelCare(): string {
        return '/customer-support';
    }
    public static get CasesList(): string {
        return 'track';
    }
    public static get BillingEnquiryList(): string {
        return '../billing/summary/enquiry';
    }
    public static get BillingEnquiryIntList(): string {
        return 'billing/summary/enquiry';
    }
    public static get OrderTrackerUnifiedTrackingEnquiries(): string {
        return 'tracking/enquiries';
    }
    public static get OrderTrackerUnifiedDashboard(): string {
        return 'dashboard';
    }
    public static get CaseDetail(): string {
        return 'enquiry/:caseId/detail';
    }
    public static get CaseDetailV6(): string {
        return 'enquiry/:caseId/detail/*';
    }
    public static get NewTicket(): string {
        return 'new-incident';
    }
    public static get Modifications(): string {
        return 'manage';
    }
    public static get DisplayFaq(): string {
        return 'faq'
    }
    public static get CaseDetailTab(): string {
        return 'enquiry/:caseId/detail/desc';
    }
    public static get SubmitEnquiry(): string {
        return 'new-enquiry';
    }
    public static get SubmitEnquiryForm(): string {
        return 'new-enquiry-form';
    }
    public static get SubmitIntEnquiry(): string {
        return 'new-enquiry?category=Billing';
    }
    public static get EnquiryDetailsTab(): string {
        return 'enquiry/:caseId/detail/';
    }
    public static get EnquiryDetailsSummaryTab(): string {
        return 'Summary';
    }
    public static get EssentialServices(): string {
        return 'essential-services';
    }
    public static get DetailedCategorySelect(): string {
        return 'select-detailed-category';
    }
    public static get SubmitDetailedEnquiry(): string {
        return 'detailed-enquiry-form';
    }
    public static ViewCaseDetail(caseId: string): string {
        return this.CaseDetail
            .replace(':caseId', encodeURIComponent(caseId));
    }

    public static ViewCaseDetailTab(caseId: string): string {
        return this.CaseDetailTab
            .replace(':caseId', encodeURIComponent(caseId));
    }

    public static submitEnquiryForInt(billingAccountId: string,
        defaultCidn: string, selectedCidn: string): string {
        const billingEnquiryNewFormInt = getDashboardFlags().billingEnquiryNewFormInt || false;
        const formPath = (billingEnquiryNewFormInt) ? 'new-enquiry-form' : 'new-enquiry';
        return (
            `${formPath}?category=Billing&billingAccountId=${billingAccountId}&selectedCidn` +
            `=${selectedCidn}&defaultCidn=${defaultCidn}`
        );
    }
    public static submitEnquiryBillingForInt(defaultCidn: string, selectedCidn: string,
        selectedCategory?: string): string {
        const billingEnquiryNewFormInt = getDashboardFlags().billingEnquiryNewFormInt || false;
        const formPath = (billingEnquiryNewFormInt) ? 'new-enquiry-form' : 'new-enquiry';
        return selectedCategory ? (
            `${formPath}?category=Billing&selectedCidn` +
                `=${selectedCidn}&defaultCidn=${defaultCidn}&subCategory=${selectedCategory}`
        ) : (
            `${formPath}?category=Billing&selectedCidn` +
                `=${selectedCidn}&defaultCidn=${defaultCidn}`
        );
    }
    public static submitOrderEnquiryForInt(refrenceNumber: string,
        defaultCidn: string, selectedCidn: string): string {
        const OrderEnquiryNewFormInt = getDashboardFlags().billingEnquiryNewFormInt || false;
        const formPath = (OrderEnquiryNewFormInt) ? 'new-enquiry-form' : 'new-enquiry';
        return (
            `${formPath}?category=Your orders&reference=${refrenceNumber}&selectedCidn` +
            `=${selectedCidn}&defaultCidn=${defaultCidn}&subCategory=General enquiry`
        );
    }
    public static submitEnquiryOrderForInt(defaultCidn: string, selectedCidn: string): string {
        const OrderEnquiryNewFormInt = getDashboardFlags().billingEnquiryNewFormInt || false;
        const formPath = (OrderEnquiryNewFormInt) ? 'new-enquiry-form' : 'new-enquiry';
        return (
            `${formPath}?category=Your orders&selectedCidn` +
            `=${selectedCidn}&defaultCidn=${defaultCidn}&subCategory=General enquiry`
        );
    }
    public static BillingEnquiryDetails(caseId: string, cidn: string): string {
        return 'enquiry/details?caseNumber=' + caseId + '&cidn=' + cidn ;
    }
}
